* {
  box-sizing: border-box;
}

:host {
  display: block;
  max-width: 100%;
}

.wrapper {
  padding: var(--spacer);
}

#gz-metadata-header {
  font-size: var(--body-size);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: calc(4 * var(--spacer));
  border: 1px solid var(--chart-101-pressed-dividers);
  padding: calc(var(--spacer));
}

.gz-metadata-header-disabled {
  pointer-events: none;
  color: var(--grey-layout-200-disabled);
}

.gz-metadata-header-enabled {
  pointer-events: auto;
  cursor: pointer;
  color: var(--black-layout-700-primary);
}

.gz-metadata-details {
  display: flex;
  gap: calc(4 * var(--spacer));
  justify-content: center;
  align-items: center;
}

.gz-metadata-view-more-button {
  background-color: transparent;
  background-repeat: no-repeat;
  border: none;
  overflow: hidden;
  outline: none;

  font-family: var(--font-family);
  font-size: var(--body-size);
}

button:disabled {
  color: var(--blue-layout-200-disabled);
  cursor: not-allowed;
}

button {
  color: var(--blue-layout-400-primary);
  cursor: pointer;
}

gz-live-search-metadata-grid {
  height: calc(50 * var(--spacer));
}

.metadata-header-values {
  font-weight: bold;
}
